"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(value, multiplier) {
  var multiplied = parseInt(value.replace(/[^0-9.]+/g, ""), 10) * multiplier;
  return multiplied + "px"; // TODO: Should use return value? unit could be suffixed where used?
};

exports["default"] = _default;